import { createRouter, createWebHashHistory, createWebHistory, } from 'vue-router';
import Layout from '@vab/layouts/index.vue';
import { setupPermissions } from './permissions';
import { authentication, isHashRouterMode, publicPath } from '@/config';
import { useRouterHelperStore } from '../store/modules/routerHelper';
export const constantRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/index.vue'),
        meta: {
            hidden: true,
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/register/index.vue'),
        meta: {
            hidden: true,
        },
    },
    {
        path: '/callback',
        name: 'Callback',
        component: () => import('@/views/callback/index.vue'),
        meta: {
            hidden: true,
        },
    },
    {
        path: '/403',
        name: '403',
        component: () => import('@/views/403.vue'),
        meta: {
            hidden: true,
        },
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/404.vue'),
        meta: {
            hidden: true,
        },
    },
    {
        path: '/customerSettlement/settlementView',
        name: 'SettlementView',
        component: () => import('@/views/finance/customerSettlement/SettlementView.vue'),
        meta: {
            hidden: true,
            title: '结算详情',
        },
    },
    {
        path: '/customerSettlement/fundsView',
        name: 'FundsView',
        component: () => import('@/views/finance/customerSettlement/FundsView.vue'),
        meta: {
            hidden: true,
            title: '账户月结',
        },
    },
    {
        path: '/monthlySettlement/customerReport',
        name: 'MonthlyCustomerReport',
        component: () => import('@/views/statistics/monthlySettlement/CustomerReport.vue'),
        meta: {
            hidden: true,
            title: '客户销量汇总报表',
        },
    },
    {
        path: '/monthlySettlement/productReport',
        name: 'MonthlyProductReport',
        component: () => import('@/views/statistics/monthlySettlement/ProductReport.vue'),
        meta: {
            hidden: true,
            title: '产品销量汇总报表',
        },
    },
    {
        path: '/monthlySettlement/statisticReport',
        name: 'MonthlyStatisticReport',
        component: () => import('@/views/statistics/monthlySettlement/StatisticReport.vue'),
        meta: {
            hidden: true,
            title: '销售汇总报表',
        },
    },
    {
        path: '/report/details',
        name: 'WeighDetailsReport',
        component: () => import('@/views/statistics/weighReport/WeighDetailsReport.vue'),
        meta: { hidden: true },
    },
    {
        path: '/report/statistics',
        name: 'WeighStatisticReport',
        component: () => import('@/views/statistics/weighReport/WeighStatisticReport.vue'),
        meta: { hidden: true },
    },
    {
        path: '/report/sinotranReport',
        name: 'DetailsReport',
        component: () => import('@/views/statistics/weighSinotransDaily/DetailsReport.vue'),
        meta: { hidden: true },
    },
    {
        path: '/report/sinotranStatistics',
        name: 'StatisticReport',
        component: () => import('@/views/statistics/weighSinotransDaily/StatisticReport.vue'),
        meta: { hidden: true },
    },
];
export const asyncRoutes = [
    {
        path: '/',
        name: 'Root',
        component: Layout,
        meta: {
            title: '主页',
            icon: 'home-2-line',
            breadcrumbHidden: true,
            hidden: true,
        },
        children: [
            {
                path: 'index/index',
                name: 'Dashboard',
                component: () => import('@/views/index/index.vue'),
                meta: {
                    title: '主页',
                    breadcrumbHidden: true,
                    icon: 'dashboard-line',
                },
            },
            {
                path: 'index/custom',
                name: 'indexCustom',
                component: () => import('@/views/index/indexCustom.vue'),
                meta: {
                    hidden: true,
                    title: '自定义首页',
                    breadcrumbHidden: true,
                },
            },
            {
                path: 'flowEdit',
                name: 'flowEdit',
                component: () => import('~/src/views/index/flow/flow-edit.vue'),
                meta: {
                    hidden: true,
                    title: '设计审批流',
                    icon: 'edit-box-line',
                },
            },
            {
                path: 'auditView',
                name: 'auditView',
                component: () => import('~/src/views/index/flow/audit-view.vue'),
                meta: {
                    hidden: true,
                    title: '审核详情',
                    dynamicNewTab: true,
                },
            },
        ],
    },
    {
        path: '/base',
        name: 'base',
        component: Layout,
        meta: {
            title: '基础',
            icon: '基础设置',
            isCustomSvg: true,
            breadcrumbHidden: true,
            guard: {
                permission: ['Base.CurrentTenant'],
            },
        },
        children: [
            {
                path: 'tenant',
                name: 'TenantList',
                component: () => import('@/views/base/tenant/TenantList.vue'),
                meta: {
                    title: '企业信息',
                    icon: '企业信息',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Base.CurrentTenant'],
                    },
                },
            },
        ],
    },
    {
        path: '/mall',
        name: 'mall',
        component: Layout,
        meta: {
            title: '商品',
            icon: 'erp-material',
            isCustomSvg: true,
            breadcrumbHidden: true,
            guard: {
                permission: ['Material.Material'],
            },
        },
        children: [
            {
                path: 'material',
                name: 'MaterialList',
                component: () => import('@/views/mall/material/MaterialList.vue'),
                meta: {
                    title: '物料管理',
                    icon: 'materialGroup',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Material.Material'],
                    },
                    editRouteName: 'MaterialEdit',
                },
            },
            {
                path: 'materialedit',
                name: 'MaterialEdit',
                component: () => import('@/views/mall/material/MaterialEdit.vue'),
                meta: {
                    hidden: true,
                    tabHidden: true,
                    title: '物料编辑',
                    activeMenu: '/mall/material',
                    listRouteName: 'MaterialList',
                },
            },
        ],
    },
    {
        path: '/sale',
        name: 'sale',
        component: Layout,
        meta: {
            title: '销售',
            icon: '销售',
            isCustomSvg: true,
            breadcrumbHidden: true,
            guard: {
                permission: [
                    'Sale.Customer',
                    'Sale.PriceOfAdjustment',
                    'Sale.PriceOfSale',
                    'Sale.CurrentPrice',
                    'Sale.HistoryPrice',
                    'Sale.CustomerDiscountPrice',
                    'Sale.OverPressDeduction',
                    'Sale.SellActivity',
                    'Sale.SaleOrder',
                    'Sale.SalesContract',
                    'Sale.TakeDeliveryPlan',
                    'Sale.WeighPriceReadjustment',
                ],
            },
        },
        children: [
            {
                path: 'customer',
                name: 'CustomerList',
                component: () => import('@/views/sale/customer/CustomerList.vue'),
                meta: {
                    title: '客户管理',
                    icon: '客户管理',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.Customer'],
                    },
                    editRouteName: 'CustomerEdit',
                },
            },
            {
                path: 'customeredit',
                name: 'CustomerEdit',
                component: () => import('@/views/sale/customer/CustomerEdit.vue'),
                meta: {
                    hidden: true,
                    title: '客户编辑',
                    activeMenu: '/sale/customer',
                    tabHidden: true,
                    listRouteName: 'CustomerList',
                },
            },
            {
                path: 'priceOfAdjustment',
                name: 'PriceOfAdjustmentList',
                component: () => import('@/views/sale/priceOfAdjustment/PriceOfAdjustmentList.vue'),
                meta: {
                    title: '物料调价管理',
                    icon: '调价',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.PriceOfAdjustment'],
                    },
                    editRouteName: 'PriceOfAdjustmentEdit',
                },
            },
            {
                path: 'priceOfAdjustmentEdit',
                name: 'PriceOfAdjustmentEdit',
                component: () => import('@/views/sale/priceOfAdjustment/PriceOfAdjustmentEdit.vue'),
                meta: {
                    hidden: true,
                    title: '调价编辑',
                    activeMenu: '/sale/priceOfAdjustment',
                    tabHidden: true,
                    listRouteName: 'PriceOfAdjustmentList',
                },
            },
            {
                path: 'priceOfSale',
                name: 'PriceOfSaleList',
                component: () => import('@/views/sale/priceOfSale/PriceOfSaleList.vue'),
                meta: {
                    title: '客户销售价管理',
                    icon: '客户价格',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.PriceOfSale'],
                    },
                    editRouteName: 'PriceOfSaleEdit',
                },
            },
            {
                path: 'priceOfSaleEdit',
                name: 'PriceOfSaleEdit',
                component: () => import('@/views/sale/priceOfSale/PriceOfSaleEdit.vue'),
                meta: {
                    hidden: true,
                    title: '销售价编辑',
                    activeMenu: '/sale/priceOfSale',
                    tabHidden: true,
                    listRouteName: 'PriceOfSaleList',
                },
            },
            {
                path: 'currentPriceList',
                name: 'CurrentPriceList',
                component: () => import('@/views/sale/currentPrice/CurrentPriceList.vue'),
                meta: {
                    title: '客户实时价格查询',
                    icon: '当前价格',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.CurrentPrice'],
                    },
                },
            },
            {
                path: 'priceTracking',
                name: 'PriceTrackingList',
                component: () => import('@/views/sale/priceTracking/PriceTrackingList.vue'),
                meta: {
                    title: '客户历史价格查询',
                    icon: '历史价格',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.HistoryPrice'],
                    },
                },
            },
            {
                path: 'weighPriceReadjustment',
                name: 'WeighPriceReadjustment',
                component: () => import('@/views/sale/weighPriceReadjustment/WeighPriceReadjustmentList.vue'),
                meta: {
                    title: '磅单价格重调',
                    icon: '改价',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.WeighPriceReadjustment'],
                    },
                },
            },
            {
                path: 'customerDiscountPrice',
                name: 'CustomerDiscountPriceList',
                component: () => import('@/views/sale/customerDiscountPrice/CustomerDiscountPriceList.vue'),
                meta: {
                    title: '客户特享价管理',
                    icon: 'icon-业务特别价格审核申请表',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.CustomerDiscountPrice'],
                    },
                    editRouteName: 'CustomerDiscountPriceEdit',
                },
            },
            {
                path: 'customerDiscountPriceEdit',
                name: 'CustomerDiscountPriceEdit',
                component: () => import('@/views/sale/customerDiscountPrice/CustomerDiscountPriceEdit.vue'),
                meta: {
                    hidden: true,
                    title: '客户特享价编辑',
                    activeMenu: '/sale/customerDiscountPrice',
                    tabHidden: true,
                    listRouteName: 'CustomerDiscountPriceList',
                },
            },
            {
                path: 'overPressDeduction',
                name: 'OverPressDeductionList',
                component: () => import('@/views/sale/overPressDeduction/OverPressDeductionList.vue'),
                meta: {
                    title: '超量抵扣管理',
                    icon: '抵扣券',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.OverPressDeduction'],
                    },
                    editRouteName: 'OverPressDeductionEdit',
                },
            },
            {
                path: 'overPressDeductionEdit',
                name: 'OverPressDeductionEdit',
                component: () => import('@/views/sale/overPressDeduction/OverPressDeductionEdit.vue'),
                meta: {
                    hidden: true,
                    title: '超量抵扣编辑',
                    activeMenu: '/sale/overPressDeduction',
                    tabHidden: true,
                    listRouteName: 'OverPressDeductionList',
                },
            },
            {
                path: 'sellActivity',
                name: 'SellActivityList',
                component: () => import('@/views/sale/sellActivity/SellActivityList.vue'),
                meta: {
                    title: '销售活动管理',
                    icon: '活动',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.SellActivity'],
                    },
                    editRouteName: 'SellActivityEdit',
                },
            },
            {
                path: 'sellActivityEdit',
                name: 'SellActivityEdit',
                component: () => import('@/views/sale/sellActivity/SellActivityEdit.vue'),
                meta: {
                    hidden: true,
                    title: '销售活动编辑',
                    activeMenu: '/sale/sellActivity',
                    tabHidden: true,
                    listRouteName: 'SellActivityList',
                },
            },
            {
                path: 'saleOrder',
                name: 'SaleOrderList',
                component: () => import('@/views/sale/saleOrder/SaleOrderList.vue'),
                meta: {
                    title: '销售订单',
                    icon: 'list_销售订单',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.SaleOrder'],
                    },
                    editRouteName: 'SaleOrderEdit',
                },
            },
            {
                path: 'saleOrderEdit',
                name: 'SaleOrderEdit',
                component: () => import('@/views/sale/saleOrder/SaleOrderEdit.vue'),
                meta: {
                    hidden: true,
                    title: '销售订单编辑',
                    activeMenu: '/sale/saleOrder',
                    tabHidden: true,
                    listRouteName: 'SaleOrderList',
                },
            },
            {
                path: 'salesContract',
                name: 'SalesContractList',
                component: () => import('@/views/sale/salesContract/SalesContractList.vue'),
                meta: {
                    title: '销售合同',
                    icon: '合同管理',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.SalesContract'],
                    },
                    editRouteName: 'SalesContractEdit',
                },
            },
            {
                path: 'salesContractEdit',
                name: 'SalesContractEdit',
                component: () => import('@/views/sale/salesContract/SalesContractEdit.vue'),
                meta: {
                    hidden: true,
                    title: '销售合同编辑',
                    activeMenu: '/sale/salesContract',
                    tabHidden: true,
                    listRouteName: 'SalesContractList',
                },
            },
            {
                path: 'takeDeliveryPlan',
                name: 'TakeDeliveryPlanList',
                component: () => import('@/views/sale/takeDeliveryPlan/TakeDeliveryPlanList.vue'),
                meta: {
                    title: '提货计划',
                    icon: '销售计划',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Sale.TakeDeliveryPlan'],
                    },
                    editRouteName: 'TakeDeliveryPlanEdit',
                },
            },
            {
                path: 'takeDeliveryPlanEdit',
                name: 'TakeDeliveryPlanEdit',
                component: () => import('@/views/sale/takeDeliveryPlan/TakeDeliveryPlanEdit.vue'),
                meta: {
                    hidden: true,
                    title: '提货计划编辑',
                    activeMenu: '/sale/takeDeliveryPlan',
                    tabHidden: true,
                    listRouteName: 'TakeDeliveryPlanList',
                },
            },
        ],
    },
    {
        path: '/procurement',
        name: 'procurement',
        component: Layout,
        meta: {
            title: '采购',
            icon: '采购管理',
            isCustomSvg: true,
            breadcrumbHidden: true,
            guard: {
                permission: ['Procurements.Supplier'],
            },
        },
        children: [
            {
                path: 'supplier',
                name: 'SupplierList',
                component: () => import('@/views/procurement/supplier/SupplierList.vue'),
                meta: {
                    title: '供应商管理',
                    icon: '供应商',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Procurements.Supplier'],
                    },
                },
            },
        ],
    },
    {
        path: '/logistic',
        name: 'logistic',
        component: Layout,
        meta: {
            title: '物流',
            icon: 'erp_9_4',
            isCustomSvg: true,
            breadcrumbHidden: true,
            guard: {
                permission: [
                    'Logistic.Carrier',
                    'Logistic.TransportCar',
                    'Logistic.DispatchOrder',
                    'Record.WeighValid',
                    'Record.WeighAccessControl',
                    'Record.WeighSendReceiveCard',
                ],
            },
        },
        children: [
            {
                path: 'transportUnit',
                name: 'CarrierList',
                component: () => import('@/views/logistic/carrier/CarrierList.vue'),
                meta: {
                    title: '承运单位管理',
                    icon: '运输单位信息',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Logistic.Carrier'],
                    },
                },
            },
            {
                path: 'logisticCar',
                name: 'logisticCar',
                component: () => import('@/views/logistic/logisticCar/CompanyCarLst.vue'),
                meta: {
                    title: '运输车辆管理',
                    icon: '货车_o',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Logistic.TransportCar'],
                    },
                    editRouteName: 'logisticCarAdd',
                },
            },
            {
                path: 'logisticCar/add',
                name: 'logisticCarAdd',
                component: () => import('@/views/logistic/logisticCar/CompanyCarEdit.vue'),
                meta: {
                    hidden: true,
                    title: '运输车辆编辑',
                    activeMenu: '/logistic/logisticCar',
                    tabHidden: true,
                    listRouteName: 'logisticCar',
                    guard: {
                        permission: ['Logistic.TransportCar'],
                    },
                },
            },
            {
                path: 'dispatchOrder',
                name: 'DispatchOrderList',
                component: () => import('@/views/logistic/dispatchOrder/DispatchOrderList.vue'),
                meta: {
                    title: '派车单管理',
                    icon: '运输单_画板 1',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Logistic.DispatchOrder'],
                    },
                    editRouteName: 'DispatchOrderEdit',
                },
            },
            {
                path: 'dispatchOrder/edit',
                name: 'DispatchOrderEdit',
                component: () => import('@/views/logistic/dispatchOrder/DispatchOrderEdit.vue'),
                meta: {
                    title: '派车单编辑',
                    hidden: true,
                    activeMenu: '/logistic/dispatchOrder',
                    tabHidden: true,
                    breadcrumbHidden: true,
                    listRouteName: 'DispatchOrderList',
                },
            },
            {
                path: 'weighInvalidRecord',
                name: 'WeighInvalidRecord',
                component: () => import('@/views/record/weighInvalidRecord/WeighInvalidRecord.vue'),
                meta: {
                    title: '作废记录',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Record.WeighValid'],
                    },
                },
            },
            {
                path: 'weighAccessControlRecord',
                name: 'weighAccessControlRecord',
                component: () => import('@/views/record/weighAccessControlRecord/WeighAccessControlRecordList.vue'),
                meta: {
                    title: '门禁记录',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Record.WeighAccessControl'],
                    },
                },
            },
            {
                path: 'weighSendReceiveCardRecord',
                name: 'weighSendReceiveCardRecord',
                component: () => import('@/views/record/weighSendReceiveCardRecord/WeighSendReceiveCardRecordList.vue'),
                meta: {
                    title: '收发卡记录',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Record.WeighSendReceiveCard'],
                    },
                },
            },
        ],
    },
    {
        path: '/stock',
        name: 'stock',
        component: Layout,
        meta: {
            title: '仓储',
            icon: '库管中心',
            isCustomSvg: true,
            breadcrumbHidden: true,
            guard: {
                permission: ['Stock.Warehouse', 'Stock.WarehousePosition'],
            },
        },
        children: [
            {
                path: 'warehouse',
                name: 'WarehouseList',
                component: () => import('@/views/stock/warehouse/WarehouseList.vue'),
                meta: {
                    title: '仓库管理',
                    icon: '10仓库、仓储-线性',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Stock.Warehouse'],
                    },
                },
            },
            {
                path: 'warehousePosition',
                name: 'WarehousePositionList',
                component: () => import('@/views/stock/warehousePosition/WarehousePositionList.vue'),
                meta: {
                    title: '仓位管理',
                    icon: '仓位集',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Stock.WarehousePosition'],
                    },
                },
            },
        ],
    },
    {
        path: '/finance',
        name: 'finance',
        component: Layout,
        meta: {
            title: '财务',
            icon: '财务管理',
            isCustomSvg: true,
            breadcrumbHidden: true,
            guard: {
                permission: [
                    'Finance.Funds',
                    'Finance.Payment',
                    'Finance.CustomerAdjustment',
                    'Finance.DeductionDetail',
                    'Finance.CustomerSettlement',
                    'Finance.CustomerCreditLimit',
                ],
            },
        },
        children: [
            {
                path: 'funds',
                name: 'FundsList',
                component: () => import('@/views/finance/funds/FundsList.vue'),
                meta: {
                    title: '账户管理',
                    icon: 'wxb账户',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Finance.Funds'],
                    },
                },
            },
            {
                path: 'payment',
                name: 'PaymentList',
                component: () => import('@/views/finance/payment/PaymentList.vue'),
                meta: {
                    title: '缴费管理',
                    icon: '缴费',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Finance.Payment'],
                    },
                    editRouteName: 'PaymentEdit',
                },
            },
            {
                path: 'paymentEdit',
                name: 'PaymentEdit',
                component: () => import('@/views/finance/payment/PaymentEdit.vue'),
                meta: {
                    hidden: true,
                    title: '缴费编辑',
                    activeMenu: '/finance/payment',
                    tabHidden: true,
                    listRouteName: 'PaymentList',
                },
            },
            {
                path: 'customerAdjustment',
                name: 'CustomerAdjustmentList',
                component: () => import('@/views/finance/customerAdjustment/CustomerAdjustmentList.vue'),
                meta: {
                    title: '客户内调',
                    icon: '缴费',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Finance.CustomerAdjustment'],
                    },
                    editRouteName: 'CustomerAdjustmentEdit',
                },
            },
            {
                path: 'customerAdjustmentEdit',
                name: 'CustomerAdjustmentEdit',
                component: () => import('@/views/finance/customerAdjustment/CustomerAdjustmentEdit.vue'),
                meta: {
                    hidden: true,
                    title: '客户内调编辑',
                    activeMenu: '/finance/customerAdjustment',
                    tabHidden: true,
                    listRouteName: 'CustomerAdjustmentList',
                },
            },
            {
                path: 'deductionDetail',
                name: 'DeductionDetailList',
                component: () => import('@/views/finance/deductionDetail/DeductionDetailList.vue'),
                meta: {
                    title: '扣费记录',
                    icon: '记录',
                    isCustomSvg: true,
                },
            },
            {
                path: 'customerSettlement',
                name: 'CustomerSettlementList',
                component: () => import('@/views/finance/customerSettlement/CustomerSettlementList.vue'),
                meta: {
                    title: '销售月结',
                    icon: '2-4结算',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Finance.CustomerSettlement'],
                    },
                },
            },
            {
                path: 'customerCreditLimit',
                name: 'CustomerCreditLimitList',
                component: () => import('@/views/finance/customerCreditLimit/CustomerCreditLimitList.vue'),
                meta: {
                    title: '客户授信额度管理',
                    icon: 'money-cny-circle-line',
                    guard: {
                        permission: ['Finance.CustomerCreditLimit'],
                    },
                    editRouteName: 'CustomerCreditLimitEdit',
                },
            },
            {
                path: 'customerCreditLimitEdit',
                name: 'CustomerCreditLimitEdit',
                component: () => import('@/views/finance/customerCreditLimit/CustomerCreditLimitEdit.vue'),
                meta: {
                    hidden: true,
                    title: '授信调整单编辑',
                    activeMenu: '/finance/customerCreditLimit',
                    tabHidden: true,
                    listRouteName: 'CustomerCreditLimitList',
                },
            },
        ],
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: Layout,
        meta: {
            title: '统计',
            icon: '统计',
            isCustomSvg: true,
            breadcrumbHidden: true,
            guard: {
                permission: [
                    'Statistics.Weigh',
                    'Statistics.WeighReport',
                    'Statistics.WeighStatistics',
                    'Statistics.WeighSinotransDaily',
                    'Statistics.MonthlySettlement',
                ],
            },
        },
        children: [
            {
                path: 'weigh',
                name: 'WeighList',
                component: () => import('@/views/statistics/weighing/WeighList.vue'),
                meta: {
                    title: '过磅查询',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Statistics.Weigh'],
                    },
                    editRouteName: 'WeighEdit',
                },
            },
            {
                path: 'weigh/edit',
                name: 'WeighEdit',
                component: () => import('@/views/statistics/weighing/WeighEdit.vue'),
                meta: {
                    title: '磅单编辑',
                    hidden: true,
                    activeMenu: '/statistics/weigh',
                    tabHidden: true,
                    breadcrumbHidden: true,
                    listRouteName: 'WeighList',
                },
            },
            {
                path: 'weighReport',
                name: 'WeighReport',
                component: () => import('@/views/statistics/weighReport/WeighReport.vue'),
                meta: {
                    title: '磅单统计',
                    icon: '过磅统计',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Statistics.WeighReport'],
                    },
                },
            },
            {
                path: 'weighReportTemplate',
                name: 'WeighReportTemplate',
                component: () => import('@/views/statistics/weighReport/WeighReportTemplate.vue'),
                meta: {
                    title: '过磅统计',
                    icon: '过磅统计',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Statistics.WeighStatistics'],
                    },
                },
            },
            {
                path: 'weighSinotransDaily',
                name: 'WeighSinotransDaily',
                component: () => import('@/views/statistics/weighSinotransDaily/WeighSinotransDaily.vue'),
                meta: {
                    title: '外运日报表',
                    icon: '12',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Statistics.WeighSinotransDaily'],
                    },
                },
            },
            {
                path: 'monthlySettlement',
                name: 'MonthlySettlementList',
                component: () => import('@/views/statistics/monthlySettlement/MonthlySettlementList.vue'),
                meta: {
                    title: '月度结算报表',
                    icon: '结算报表',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Statistics.MonthlySettlement'],
                    },
                },
            },
        ],
    },
    // {
    //   path: '/record',
    //   name: 'record',
    //   component: Layout,
    //   meta: {
    //     title: '记录',
    //     icon: 'home-2-line',
    //     breadcrumbHidden: true,
    //   },
    //   children: [],
    // },
    {
        path: '/oa',
        name: 'oa',
        component: Layout,
        meta: {
            title: '行政',
            icon: '行政',
            isCustomSvg: true,
            breadcrumbHidden: true,
            guard: {
                permission: [
                    'Identity.Users',
                    'Identity.Roles',
                    'Identity.Department',
                    'Identity.Position',
                    'Identity.CompanyCar',
                ],
            },
        },
        children: [
            {
                path: 'user',
                name: 'UserList',
                component: () => import('@/views/oa/user/UserList.vue'),
                meta: {
                    title: '用户管理',
                    icon: '用户管理',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Identity.Users'],
                    },
                },
            },
            {
                path: 'role',
                name: 'RoleList',
                component: () => import('@/views/oa/role/RoleList.vue'),
                meta: {
                    title: '角色管理',
                    icon: '角色管理',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Identity.Roles'],
                    },
                },
            },
            {
                path: 'role/home-module',
                name: 'home-module',
                component: () => import('@/views/index/indexCustom.vue'),
                meta: {
                    hidden: true,
                    title: '角色首页配置',
                    activeMenu: '/oa/role',
                },
            },
            {
                path: 'role/flowInfo',
                name: 'RoleFlowInfo',
                component: () => import('@/views/oa/role/RoleFlowInfo.vue'),
                meta: {
                    hidden: true,
                    title: '业务权限配置',
                    activeMenu: '/oa/role',
                    tabHidden: true,
                    listRouteName: 'RoleList',
                },
            },
            {
                path: 'department',
                name: 'DepartmentList',
                component: () => import('@/views/oa/department/DepartmentList.vue'),
                meta: {
                    title: '组织结构管理',
                    icon: 'organization-structure',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Identity.Department'],
                    },
                },
            },
            {
                path: 'position',
                name: 'PositionList',
                component: () => import('@/views/oa/position/PositionList.vue'),
                meta: {
                    title: '职务管理',
                    icon: '职务管理',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Identity.Position'],
                    },
                },
            },
            {
                path: 'companyCar',
                name: 'CompanyCarLst',
                component: () => import('@/views/oa/companyCar/CompanyCarLst.vue'),
                meta: {
                    title: '行政车辆管理',
                    icon: '行政车辆进出记录备份',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Identity.CompanyCar'],
                    },
                },
            },
        ],
    },
    {
        path: '/setting',
        name: 'setting',
        component: Layout,
        meta: {
            title: '系统',
            icon: '系统',
            isCustomSvg: true,
        },
        children: [
            {
                path: 'workUnit',
                name: 'WorkUnitList',
                component: () => import('@/views/setting/workUnit/WorkUnitList.vue'),
                meta: {
                    title: '公司管理',
                    icon: '公司管理',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.WorkUnit'],
                    },
                },
            },
            {
                path: 'creditRating',
                name: 'CreditRatingList',
                component: () => import('@/views/setting/creditRating/CreditRatingList.vue'),
                meta: {
                    title: '信誉等级管理',
                    icon: '教师评价',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.CreditRating'],
                    },
                },
            },
            {
                path: 'messageTemplate',
                name: 'MessageTemplateList',
                component: () => import('@/views/setting/messageTemplate/MessageTemplateList.vue'),
                meta: {
                    title: '消息模板管理',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.MessageTemplate'],
                    },
                },
            },
            {
                path: 'dataDic',
                name: 'DataDicList',
                component: () => import('@/views/setting/dataDic/DataDicList.vue'),
                meta: {
                    title: '数据字典管理',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.DataDic'],
                    },
                },
            },
            {
                path: 'carType',
                name: 'CarTypeList',
                component: () => import('@/views/setting/carType/CarTypeList.vue'),
                meta: {
                    title: '车型管理',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.CarType'],
                    },
                    editRouteName: 'CarTypeEdit',
                },
            },
            {
                path: 'carTypeEdit',
                name: 'CarTypeEdit',
                component: () => import('@/views/setting/carType/CarTypeEdit.vue'),
                meta: {
                    hidden: true,
                    title: '车型编辑',
                    activeMenu: '/setting/carType',
                    tabHidden: true,
                    listRouteName: 'CarTypeList',
                },
            },
            {
                path: 'customizeParameter',
                name: 'CustomizeParameterList',
                component: () => import('@/views/setting/customizeParameter/CustomizeParameterList.vue'),
                meta: {
                    title: '自定义字段管理',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.CustomizeParameter'],
                    },
                    editRouteName: 'CustomizeParameterEdit',
                },
            },
            {
                path: 'customizeParameterEdit',
                name: 'CustomizeParameterEdit',
                component: () => import('@/views/setting/customizeParameter/CustomizeParameterEdit.vue'),
                meta: {
                    hidden: true,
                    title: '自定义字段编辑',
                    activeMenu: '/setting/customizeParameter',
                    tabHidden: true,
                    listRouteName: 'CustomizeParameterList',
                },
            },
            {
                path: 'flowInfo',
                name: 'FlowInfoList',
                component: () => import('@/views/setting/flowInfo/FlowInfoList.vue'),
                meta: {
                    title: '业务类型管理',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.FlowInfo'],
                    },
                },
            },
            {
                path: 'tableFieldMust',
                name: 'TableFieldMustList',
                component: () => import('@/views/setting/tableFieldMust/TableFieldMustList.vue'),
                meta: {
                    title: '字段必录控制',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.TableFieldMust'],
                    },
                },
            },
            {
                path: 'menu',
                name: 'MenuList',
                component: () => import('@/views/setting/menu/MenuList.vue'),
                meta: {
                    title: '小程序资源',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.Menu'],
                    },
                },
            },
            {
                path: 'guide',
                name: 'GuideList',
                component: () => import('@/views/setting/guide/GuideList.vue'),
                meta: {
                    title: '提货须知',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.Guide'],
                    },
                },
            },
            {
                path: 'blacklist',
                name: 'BlacklistList',
                component: () => import('@/views/setting/blacklist/BlacklistList.vue'),
                meta: {
                    title: '驾驶员黑名单',
                    icon: '黑名单',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Setting.Tenant.Blacklist'],
                    },
                },
            },
            {
                path: 'myDownload',
                name: 'MyDownloadList',
                component: () => import('@/views/setting/myDownload/MyDownloadList.vue'),
                meta: {
                    title: '我的下载',
                    icon: '下载',
                    isCustomSvg: true,
                },
            },
        ],
    },
    {
        path: '/log',
        name: 'Log',
        component: Layout,
        meta: {
            title: '日志',
            icon: '日志',
            isCustomSvg: true,
            guard: {
                permission: [
                    'Log.Tenant.EntityChangeLog',
                    'Log.Tenant.VisitorLog',
                    'Log.Tenant.ClientWarningLog',
                    'Log.Tenant.HistoryLog'
                ],
            },
        },
        children: [
            {
                path: 'tenant-entitylog',
                name: 'TenantEntityChangeLog',
                component: () => import('@/views/setting/logging/entityChangeLog/TenantEntityChangeLog.vue'),
                meta: {
                    title: '操作日志',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Log.Tenant.EntityChangeLog'],
                    },
                },
            },
            {
                path: 'visitorLog',
                name: 'VisitorLog',
                component: () => import('@/views/setting/logging/visitorLog/VisitorLog.vue'),
                meta: {
                    title: '访客日志',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Log.Tenant.VisitorLog'],
                    },
                },
            },
            {
                path: 'clientWarningLog',
                name: 'ClientWarningLog',
                component: () => import('@/views/setting/logging/clientWarningLog/ClientWarningLog.vue'),
                meta: {
                    title: '终端告警日志',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Log.Tenant.ClientWarningLog'],
                    },
                },
            },
            {
                path: 'OperateLog',
                name: 'OperateLog',
                component: () => import('@/views/setting/logging/operateLog/OperateLog.vue'),
                meta: {
                    title: '历史操作日志',
                    icon: '记录',
                    isCustomSvg: true,
                    guard: {
                        permission: ['Log.Tenant.HistoryLog'],
                    },
                },
            },
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404',
        name: 'NotFound',
        meta: {
            hidden: true,
        },
    },
];
const router = createRouter({
    history: isHashRouterMode
        ? createWebHashHistory(publicPath)
        : createWebHistory(publicPath),
    routes: constantRoutes,
});
function fatteningRoutes(routes) {
    return routes.flatMap((route) => {
        return route.children ? fatteningRoutes(route.children) : route;
    });
}
function addRouter(routes) {
    routes.forEach((route) => {
        if (!router.hasRoute(route.name))
            router.addRoute(route);
        if (route.children)
            addRouter(route.children);
    });
}
export function resetRouter(routes = constantRoutes) {
    routes.map((route) => {
        if (route.children)
            route.children = fatteningRoutes(route.children);
    });
    router.getRoutes().forEach(({ name }) => {
        router.hasRoute(name) &&
            router.removeRoute(name);
    });
    addRouter(routes);
}
export function setupRouter(app) {
    if (authentication === 'intelligence')
        addRouter(asyncRoutes);
    setupPermissions(router);
    app.use(router);
    return router;
}
router.beforeEach((to, from, next) => {
    const routerHelper = useRouterHelperStore();
    if (to.meta && to.meta.editRouteName) {
        const listName = to.name;
        const editStatus = routerHelper.getEditStatus(listName);
        const isBackFromEdit = from.name === to.meta.editRouteName && editStatus.isEditing;
        // 手机端：菜单/导航回到列表一律显示列表页，不因残留的"编辑中"状态回跳编辑页
        // （桌面端保留原逻辑：支持从列表 tab 唤起编辑页）
        if (typeof window !== 'undefined' && document.documentElement.clientWidth <= 480) {
            routerHelper.clearEditStatus(listName);
            next();
            return;
        }
        if (editStatus.isEditing && !isBackFromEdit) {
            next(editStatus.route);
            return;
        }
        routerHelper.clearEditStatus(listName);
        next();
        return;
    }
    if (to.meta && to.meta.listRouteName) {
        const listName = to.meta.listRouteName;
        if (!routerHelper.getEditStatus(listName).isEditing) {
            routerHelper.setEditStatus(listName, { name: to.name, query: to.query });
        }
        next();
        return;
    }
    next();
});
export default router;
